var $ = require("jquery");
var scrollMonitor = require("scrollmonitor");
var FontFaceObserver = require('fontfaceobserver');
import { animateCss, animateCssViewport } from "./animateCss";
import 'lazysizes';

// https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap
// https://fonts.bunny.net/css?family=Montserrat:wght@300;400;500;600;700&display=swap
var font = new FontFaceObserver('Montserrat');
font.load().then(function () {
  // console.log('Montserrat has loaded');
});

jQuery(function () {

  // header behavior and global content automatic animations
  // animateCss('header', 'fadeIn').then((message) => {
  //   animateCssViewport();
  // });
  animateCssViewport();

  // effect on homepage header
  var $header = $('header#homepage-header');
  // if ($header.length) {
  //   var $screenshow = $('div#homepage-show');
  //   var $main = $('main#homepage-main');
  //   var headerWatcher = scrollMonitor.create($header);
  //   var screenshowWatcher = scrollMonitor.create($screenshow);
  //   headerWatcher.lock();
  //   screenshowWatcher.lock();
  //   animateCss('header#homepage-header', 'slideInDown');

  //   screenshowWatcher.visibilityChange(function () {
  //     if (!screenshowWatcher.isBelowViewport) {
  //       animateCss('header#homepage-header', 'slideInDown');
  //     }
  //   });
  // }

  // animatecss on hover
  $(".animate__hover").on('hover', function () {
    animateCss($(this), $(this).data('anim-hover'));
  });

  // navbar and menu stuff
  $('#menu-button').on('click', function () {
    $('#menu-icon, #close-icon').toggleClass('block hidden');
    $('#menu').slideToggle("slow");
  });

  $('#info-mobile-button').on('click', function () {
    $('#info-mobile-content').slideToggle();
  });

  $('#user-menu-button').on('click', function () {
    $('#user-menu').toggleClass('block hidden');
    $('#user-menu-button-closer').toggleClass('hidden fixed')
  });

  $('#user-menu-button-closer').on('click', function () {
    $('#user-menu').toggleClass('block hidden');
    $(this).removeClass('fixed').addClass('hidden');
  });

  // handle esc keyboard button to close user menu
  $(document).keyup(function (e) {
    if (e.key === 'Esc' || e.key === 'Escape') {
      let userMenuButtonCloser = $('#user-menu-button-closer');
      if (userMenuButtonCloser.hasClass('fixed')) {
        userMenuButtonCloser.trigger('click');
        console.log('esc button triggered');
      }
    }
  });

  // end navbar and menu stuff

  // widget servizi e team
  $('#box-menu > button').on('click', function(){
    var classesMenu = 'bg-indigodye bg-opacity-50 box-active';
    $(this).parent().find('button.box-active').toggleClass(classesMenu);
    $(this).addClass(classesMenu);
    var newSlug = $(this).data('show');
    $('#box-content > div.box-active').toggleClass('hidden box-active');
    $('#box-content > div#'+newSlug).toggleClass('hidden box-active');
  });

  $('#box-menu-mobile select').on('change', function(){
    var newSlug = $(this).val();
    $('#box-content > div.box-active').toggleClass('hidden box-active');
    $('#box-content > div#'+newSlug).toggleClass('hidden box-active');
  });

  /* events analytics */
  // analytics phone tracking event
  $('a[href^="tel:"]').on('click', function () {
      if (typeof gtag === 'function') {
        gtag('event', 'generate_lead', {
          'event_category': 'phone',
          'event_action': 'click',
          'event_label': 'tel'
        });
        console.log('phone click tracked');
      }
      if (typeof fbq === 'function' ) {
        fbq('track', 'Contact');
      }
  });

  // analytics email tracking event
  $('a[href^="mailto:"]').on('click', function () {
      if (typeof gtag === 'function') {
        gtag('event', 'generate_lead', {
          'event_category': 'mailto',
          'event_action': 'click',
          'event_label': 'mailto'
        });
        console.log('email click tracked');
      }
      if (typeof fbq === 'function' ) {
        fbq('track', 'Contact');
      }
  });

})
